import { logEvent, type Analytics } from 'firebase/analytics';
import { getFirebaseAnalytics } from './firebase';

export const WEB_STORE_CLICK = 'web_store_click';
export const WEB_DOWNLOAD_PAGE_VIEW = 'web_download_page_view';
export const WEB_REFERRAL_COPY = 'web_referral_copy';
export const WEB_QUIZ_SELECT = 'web_quiz_select';
export const WEB_QUIZ_START = 'web_quiz_start';
export const WEB_QUIZ_COMPLETE = 'web_quiz_complete';
export const WEB_QUIZ_LOCKED_VIEW = 'web_quiz_locked_view';
export const WEB_NAV_CLICK = 'web_nav_click';
export const WEB_BLOG_VIEW = 'web_blog_view';
export const WEB_CONTACT_SUBMIT = 'web_contact_submit';
export const WEB_PARTNER_SIGNUP = 'web_partner_signup';
export const WEB_PARTNER_LOGIN = 'web_partner_login';
export const WEB_LANDING = 'web_landing';

type EventParams = Record<string, string | number | boolean | undefined>;

let analyticsPromise: Promise<Analytics | null> | null = null;
let landingLogged = false;

function getAnalytics(): Promise<Analytics | null> {
  if (!analyticsPromise) {
    analyticsPromise = getFirebaseAnalytics();
  }
  return analyticsPromise;
}

export async function trackEvent(name: string, params?: EventParams): Promise<void> {
  const analytics = await getAnalytics();
  if (!analytics) return;
  const cleaned = params
    ? Object.fromEntries(
        Object.entries(params).filter(([, v]) => v !== undefined && v !== ''),
      )
    : undefined;
  logEvent(analytics, name, cleaned);
}

function parseLandingParams(search: string): EventParams {
  const params = new URLSearchParams(search);
  return {
    utm_source: params.get('utm_source') ?? undefined,
    utm_medium: params.get('utm_medium') ?? undefined,
    utm_campaign: params.get('utm_campaign') ?? undefined,
    utm_content: params.get('utm_content') ?? undefined,
    utm_term: params.get('utm_term') ?? undefined,
    ref: params.get('ref') ?? undefined,
    referrer: typeof document !== 'undefined' ? document.referrer || undefined : undefined,
  };
}

export async function trackPageView(path: string, title?: string): Promise<void> {
  const pageTitle = title ?? (typeof document !== 'undefined' ? document.title : '');
  const pageLocation = typeof window !== 'undefined' ? window.location.href : '';

  await trackEvent('page_view', {
    page_path: path,
    page_title: pageTitle,
    page_location: pageLocation,
  });

  if (!landingLogged && typeof window !== 'undefined') {
    landingLogged = true;
    const [, search = ''] = path.split('?');
    const landingParams = parseLandingParams(search || window.location.search);
    const hasAttribution = Object.values(landingParams).some(Boolean);
    if (hasAttribution || path === '/' || path.startsWith('/?')) {
      await trackEvent(WEB_LANDING, {
        page_path: path.split('?')[0] || '/',
        ...landingParams,
      });
    }
  }
}
